import { IObj } from 'constants/types/common.types'

const MESSAGE_MAX_WIDTH = 400
const LIMIT_TOP_VALUE = 230

/* TODO добавить jsDoc */
const createMessageStyle = (messageNode: HTMLElement) => {
  const { right, left, top, bottom } = messageNode.getBoundingClientRect() as DOMRectReadOnly
  const styleObj: IObj<string> = {}

  styleObj.maxWidth = `${MESSAGE_MAX_WIDTH}px`

  if (left < window.innerWidth - MESSAGE_MAX_WIDTH) {
    styleObj.left = `${left}px`
  } else if (right > MESSAGE_MAX_WIDTH) {
    styleObj.right = `${window.innerWidth - right}px`
  } else {
    styleObj.left = '15px'
    styleObj.maxWidth = '100%'
  }

  if (top < LIMIT_TOP_VALUE) {
    styleObj.top = `${bottom + 10}px`
  } else {
    styleObj.top = `${top - 10}px`
    styleObj.transform = 'translateY(-100%)'
  }

  return styleObj
}

export { createMessageStyle }
